"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** GoogleIcon */


var GoogleIcon = function GoogleIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Google Icon" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.G, {
    width: "17",
    height: "18",
    fill: "none",
    viewBox: "0 0 17 18"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M16.759 9.194a9.82 9.82 0 00-.156-1.75H8.551v3.308h4.601a3.933 3.933 0 01-1.706 2.58v2.146h2.763c1.617-1.489 2.55-3.68 2.55-6.284z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M8.55 17.55c2.31 0 4.245-.765 5.66-2.07l-2.764-2.146c-.765.513-1.745.816-2.895.816-2.227 0-4.112-1.504-4.784-3.525H.91v2.215a8.547 8.547 0 007.64 4.71z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M3.766 10.624a5.14 5.14 0 01-.268-1.625c0-.563.097-1.111.268-1.624V5.16H.909A8.547 8.547 0 000 9c0 1.38.33 2.685.91 3.84l2.856-2.216z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M8.55 3.85c1.256 0 2.383.431 3.27 1.278l2.451-2.452C12.791 1.296 10.855.45 8.552.45A8.547 8.547 0 00.91 5.16l2.856 2.216C4.439 5.354 6.324 3.85 8.55 3.85z",
    clipRule: "evenodd"
  })));
};

exports.GoogleIcon = GoogleIcon;
GoogleIcon.displayName = "GoogleIcon";